import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Drawer from '@base/Drawer/Drawer';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import { Spacings } from '@styles/index';
import { useIsMobile } from '@stores/AppCommonData';
import useAccessControl from '@api/hooks/auth/useAccessControl';

import InviteCode from './InviteCode/InviteCode';
import CreditsStep from './CreditsStep/CreditsStep';

import InviteCodeMobile from './InviteCode/InviteCodeMobile';

import YouAreIn from './YouAreIn';

const Title = styled(H2)`
  margin-top: ${Spacings.SPACING_10B};
  grid-column: span 10;
`;

const UserInfo = styled(P1)`
  margin-top: ${Spacings.SPACING_3B};
  grid-column: span 10;
`;

const StepContainer = styled.div`
  margin-top: ${Spacings.SPACING_10B};
  grid-column: span 10;
`;

const getUserInfoString = (me = {}) => {
  const separator = '\u00a0\u00a0•\u00a0\u00a0';
  let info = '';
  if (me.phone) {
    info += `+${me.country?.phone_code} ${me.phone}`;
  }
  if (me.email) {
    info += `${info ? separator : ''}${me.email}`;
  }
  if (me.state) {
    info += `${info ? separator : ''}${me.state}`;
  }
  return info;
};

const steps = {
  inviteCode: 'inviteCode',
  credits: 'credits',
  youAreInMobile: 'youAreInMobile'
};

const EnrollFlow = ({
  show,
  closeFlow,
  enroll,
  goalUID,
  goalSlug,
  selectedCombatInfo
}) => {
  const isMobile = useIsMobile();
  const me = useSelector(({ auth }) => auth.me);
  const { accessControl } = useAccessControl();
  const [step, setStep] = useState(() => {
    if (accessControl?.isFirstContest) return steps.inviteCode;
    return steps.credits;
  });

  const onStepClose = () => {
    setStep('');
    setTimeout(closeFlow, 250);
  };
  return (
    <>
      {!isMobile && steps.inviteCode === step && (
        <Drawer drawerState={show} onClose={closeFlow}>
          <Title>{me?.name}</Title>
          <UserInfo>{getUserInfoString(me)}</UserInfo>
          <StepContainer>
            <InviteCode enroll={enroll} />
          </StepContainer>
        </Drawer>
      )}
      {isMobile && (
        <>
          <YouAreIn
            show={step === steps.youAreInMobile}
            onClose={onStepClose}
            goalUID={goalUID}
            goalSlug={goalSlug}
            selectedCombatInfo={selectedCombatInfo}
          />
          <InviteCodeMobile
            enroll={enroll}
            onClose={onStepClose}
            show={step === steps.inviteCode}
          />
        </>
      )}
      <CreditsStep
        show={step === steps.credits}
        onClose={onStepClose}
        enroll={enroll}
        goalUID={goalUID}
        goalSlug={goalSlug}
        selectedCombatInfo={selectedCombatInfo}
      />
    </>
  );
};

EnrollFlow.propTypes = {
  show: PropTypes.bool.isRequired,
  closeFlow: PropTypes.func.isRequired,
  enroll: PropTypes.func.isRequired,
  goalUID: PropTypes.string.isRequired,
  goalSlug: PropTypes.string.isRequired,
  selectedCombatInfo: PropTypes.objectOf(PropTypes.any).isRequired
};

export default EnrollFlow;
